import { Box, Divider } from '@ltvco/refresh-lib/theme';
import { CommunityBuzz, MyGarageContainer } from '@ltvco/refresh-lib/v2';
import { useEffect } from 'react';

import { useAurelia } from 'components/Aurelia/useAurelia';
import { Marketplace } from 'components/Marketplace/Marketplace';
import { Rewards } from 'components/Rewards/Rewards';

export function MyGarage() {
  const {
    savedVehicles: { data: savedVehiclesData },
    savedSearches: { data: savedSearchesData },
    listedVehicles: { data: listedVehiclesData },
  } = useAurelia();

  useEffect(() => {
    document.title = 'My Vehicle - Bumper';
  }, []);

  return (
    <Box>
      <MyGarageContainer
        title="My Garage"
        communityBuzz={(vehicle) => (
          <CommunityBuzz
            make={vehicle.make || ''}
            model={vehicle.model || ''}
            year={vehicle.year?.toString() || ''}
            trim={vehicle.trim || 'Base'}
            limitIntroModalToSession={true}
          />
        )}
      >
        <Marketplace
          savedVehiclesCount={savedVehiclesData?.total_listings}
          savedSearchesCount={savedSearchesData?.total_user_searches}
          listedVehiclesCount={listedVehiclesData?.total_vehicles}
        />
        <Divider sx={{ marginTop: '3rem', marginBottom: '2.5rem' }} />
        <Rewards />
      </MyGarageContainer>
    </Box>
  );
}
